<template>
  <a-page-heading>デスクトップ通知設定</a-page-heading>
  <m-section>
    <m-action-card title="デスクトップ通知設定" icon="sound" :header-border="true" :narrow-body="true">
      <form ref="form" class="t-profile-edit-user-info__form" @submit.prevent="handleFormSubmit">
        <div class="t-profile-edit-password__fields">
          <m-form-input label="デスクトップ通知ON／OFF">
            <a-switch id="notificationEditSwitch" v-model="notificationFlag" />
          </m-form-input>
          <m-form-input label="ブラウザの通知設定の状態">
            <a-text id="notificationSettingInfo">{{ notificationPermission }}</a-text>
          </m-form-input>
        </div>
        <m-form-action-buttons class="t-profile-edit-user-info__buttons">
          <a-button
            id="notificationSaveButton"
            variant="block"
            color="primary"
            :disabled="settingDisabled"
            @click="handleNotificationChange"
          >
            保存
          </a-button>
          <a-button id="notificationSaveCancelButton" variant="outlined" color="primary" @click="handleCancelClick"
            >キャンセル</a-button
          >
        </m-form-action-buttons>
      </form>
    </m-action-card>
  </m-section>
</template>

<script>
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';

export default {
  name: 't-profile-edit-notification',
  components: {},
  mixins: [customRequest],
  props: {},
  data() {
    return {
      notificationFlag: true,
      notificationPermission: messageContent.notificationDefault,
      settingDisabled: false,
      companyID: '',
      userID: '',
    };
  },
  computed: {},
  created() {},
  mounted() {
    // ブラウザの通知設定を確認
    Notification.requestPermission()
      .then(permission => {
        if (permission === 'granted') {
          this.notificationPermission = messageContent.notificationGranted;
        } else if (permission === 'denied') {
          this.notificationPermission = messageContent.notificationDenied;
        } else if (permission === 'default') {
          this.notificationPermission = messageContent.notificationDefault;
        } else {
          this.notificationPermission = messageContent.notificationDisable;
        }
      })
      .catch(err => {
        console.error('Notification requestPermission error: ' + err);
        this.notificationPermission = messageContent.notificationSettingError;
      });

    // クエリパラメータからcompanyIDとuserIDを取得
    const queryObj = {};
    const queryStr = window.location.search;
    if (queryStr) {
      const parametersStr = queryStr.substring(1);
      const parametersArr = parametersStr.split('&');
      for (const parameter of parametersArr) {
        const element = parameter.split('=');
        queryObj[decodeURIComponent(element[0])] = decodeURIComponent(element[1]);
      }
      this.companyID = queryObj['companyID'];
      this.userID = queryObj['userID'];
    }

    if (this.companyID && this.userID) {
      // notificationFlagの情報を取得
      this.postRequest('/idmgmt/getNotificationFlag', { companyID: this.companyID, userID: this.userID }).then(e => {
        if (e.data) {
          if (e.data.flag === null || typeof e.data.flag === 'undefined') {
            this.notificationFlag = true;
          } else {
            this.notificationFlag = e.data.flag;
          }
        }
      });
    } else {
      this.settingDisabled = true;
    }
  },
  methods: {
    handleCancelClick() {
      this.$router.push('/profilelist');
    },
    handleNotificationChange() {
      if (this.settingDisabled === false) {
        this.postRequest('/idmgmt/setNotificationFlag', {
          companyID: this.companyID,
          userID: this.userID,
          data: {
            notificationFlag: this.notificationFlag,
          },
        }).then(async e => {
          if (e.status) {
            if (this.notificationFlag === true) {
              await Notification.requestPermission()
                .then(permission => {
                  if (permission === 'granted') {
                    console.log('granted');
                  } else if (permission === 'denied') {
                    console.log('denied');
                  } else if (permission === 'default') {
                    console.log('default');
                  }
                })
                .catch(err => {
                  console.error('Notification requestPermission error ' + err);
                });
            }
            location.href = '/profilelist';
          }
        });
      }
    },
  },
};
</script>
